import React, { useEffect, useState } from "react";
import case_under from "../../images/case_under.png";
import phone from "../../images/phone-flip.png";
import case_picture from "../../images/case-img-main.png";
import united_logo from "../../images/united-logo.png";
import Seo from "../Seo";
import { Helmet } from "react-helmet";
import { Route, useParams } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { scAxiosAdmin } from "../..";
import { API_TOKEN_NAME } from "../../constants";
const CareerInside = () => {
  const data = [
    {
      title: "VACANCY",
      points: ["2"],
    },
    {
      title: "JOB RESPONSIBILITIES",
      points: [
        "Provide treatment of indoor and outdoor patient independently.Treat acute and chronic illnesses and provides preventive care and health education to patients.",
      ],
    },
    {
      title: "EMPLOYMENT STATUS",
      points: ["Part-time, Contractual"],
    },
    {
      title: "EDUCATIONAL REQUIREMENTS",
      points: [
        "2Bachelor of Medicine and Bachelor of Surgery(MBBS), Post Graduate Diploma (PGD)",
        "Preferred Professional Certification: Cretificate courses on health and health education,FCGP, PGT, CCD etc",
        "Training/Trade Course: Post graduate diploma",
      ],
    },
    {
      title: "EXPERIENCE REQUIREMENTS",
      points: [
        "1 to 5 year(s)",
        "The applicants should have experience in the following area(s): Doctor/ Consultant",
      ],
    },
    {
      title: "ADDITIONAL REQUIREMENTS",
      points: [
        "Age 28 to 60 years",
        "Both males and females are allowed to apply",
      ],
    },
    {
      title: "Job Location",
      points: ["Gulshan-2, Dhaka, Bangladesh."],
    },
    {
      title: "Salary",
      points: ["Salary"],
    },
    {
      title: "Compensation & Other Benefits",
      points: ["Over time allowance"],
    },
  ];
  const [searchResults, setSearchResults] = useState({});
  const [departmentId, setDepartmentId] = useState();
  const [loading, setLoading] = useState(false);
  const route = useParams();
  const [scheduleReqData, setScheduleReqData] = useState({
    DoctorID: "",
    PreferredDate: "",
    doctorData: "",
  });
  useEffect(() => {
    const getJobOpenings = (data) => {
      try {
        setLoading(true);
        const req = scAxiosAdmin
          .request(`/jobs/${route.id}`, {
            method: "get",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
            },
          })
          .then((data) => {
            if (data.status === 200) {
              setLoading(false);
              setSearchResults(data.data);
            }
          })
          .catch((e) => {
            setLoading(false);
            console.log("your log output", e);
          });
      } catch (error) {}
    };
    getJobOpenings();
  }, []);

  function formatDates(startDate, endDate) {
    function formatDate(dateStr) {
      const date = new Date(dateStr);

      const day = date.getDate();
      const year = date.getFullYear();

      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const month = monthNames[date.getMonth()];

      return {
        date: day,
        year: `${month} ${year}`,
      };
    }

    function formatDeadlineDate(dateStr) {
      const date = new Date(dateStr);

      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    }

    const start = formatDate(startDate);
    const end = formatDate(endDate);

    const deadline = `${formatDeadlineDate(startDate)} - ${formatDeadlineDate(
      endDate
    )}`;

    return {
      start: start,
      end: end,
      deadline: deadline,
    };
  }
  return (
    <div>
      <Seo
        title={`${searchResults.position_title} | Best Hospital in Bangladesh | United Hospital`}
        description="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        pathSlug="/"
        keywords="Death Certificate"
      />
      <Helmet>
        <meta
          name="description"
          content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "LocalBusiness",
            name: "United Hospital Limited",
            image:
              "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
            telephone: "10666",
            email: "info@uhlbd.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "plot 15, Road 71, Gulshan",
              addressLocality: "Dhaka",
              addressRegion: "Dhaka",
              addressCountry: "Bangladesh",
              postalCode: "1212",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              opens:
                "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
            },
            url: "http://www.uhlbd.com/",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "3.9",
              bestRating: "5",
              worstRating: "1",
              ratingCount: "756",
            },
            review: {
              "@type": "Review",
              author: {
                "@type": "Person",
                name: "abdul kahar",
              },
              datePublished: "2019-02-12",
              reviewRating: {
                "@type": "Rating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
              },
              reviewBody:
                "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
            },
          })}
        </script>
        <meta
          name="Subject"
          content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
        />
        <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
        <meta name="Googlebot" content="all" />
        <meta http-equiv="imagetoolbar" content="no" />
        <meta name="robots" content="index, follow" />
        <meta name="copyright" content="Copyright &copy; uhlbd.com" />
        <meta name="owner" content="United Hospital" />
        <meta name="author" content="dcastalia.com" />
        <meta name="Rating" content="General" />
        <meta name="distribution" content="Global" />
        <meta
          name="classification"
          content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta
          names="apple-mobile-web-app-status-bar-style"
          content="black-translucent"
        />
        <meta name="msvalidate.01" content="16C4E0B16E39354E550F64BD707F6A97" />
      </Helmet>
      <Route component={Header} />
      <div id="giveMargin" style={{ backgroundColor: "#fef3e9" }}>
        <section className="banner-hero">
          <img
            src="/assets/images/banner-case-study.png"
            alt="banner-profile"
            className="w-100"
          />
        </section>
        <section className="container">
          <div className="d-flex flex-column justify-content-between align-items-center p-4">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <h3
                className="text-center"
                style={{
                  color: "#0C807D",
                  fontSize: "28px",
                  fontWeight: "500",
                  
                }}
              >
                Job Details
              </h3>
              {/* <img width={63} src="/assets/images/doctor_under.png" alt="" /> */}
            </div>
          </div>
        </section>
        {searchResults ? (
          <main>
            <section class="container">
              <div className="d-flex flex-column flex-lg-row pt-3 pb-3 justify-content-between w-100">
                <div
                  className="d-flex pt-3 pb-3 justify-content-start align-items-start  w-75"
                  // style={{ backgroundColor: "#E7F2F2" }}
                >
                  <img
                    src="/assets/images/united_logo.png"
                    alt=""
                    style={{ width: "10%", height: "63px" }}
                  />
                  <img
                    className="ms-4"
                    src={case_under}
                    alt=""
                    width={3}
                    height={63}
                  />
                  <div className="d-flex flex-column w-100">
                    <h3
                      className="px-4 "
                      style={{
                        fontSize: "22px",
                        textTransform: "capitalize",
                      }}
                    >
                      {searchResults.position_title}
                    </h3>
                    <div className="d-flex px-4">
                      <div className="d-flex justify-content-center align-items-center">
                        <img src="/assets/images/job_person.png" alt="" />
                        <p className="ps-2 fw-bold">{searchResults.company}</p>
                      </div>
                      <div className="d-flex justify-content-center align-items-center ps-3">
                        <img src="/assets/images/job_calander.png" alt="" />
                        <p
                          style={{ color: "#AF9763" }}
                          className="ps-2 fw-bold"
                        >
                          {
                            formatDates(
                              searchResults.posting_date,
                              searchResults.deadline
                            ).deadline
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    // width: "20%",
                    borderRadius: "5px",
                    backgroundColor: "#E7F2F2",
                  }}
                  className="applyDate d-flex flex-column align-items-center justify-content-between"
                >
                  <div className="">
                    <h2 style={{ color: "#0C807D" }}>
                      {
                        formatDates(
                          searchResults.posting_date,
                          searchResults.deadline
                        ).start.date
                      }
                    </h2>
                  </div>
                  <div
                    className="w-100  d-flex align-items-center justify-content-center"
                    style={{
                      backgroundColor: "#0C807D",
                      borderBottomLeftRadius: "5px",
                      borderBottomRightRadius: "5px",
                    }}
                  >
                    <h6 className="mb-0 py-2" style={{ color: "#ffffff" }}>
                      {
                        formatDates(
                          searchResults.posting_date,
                          searchResults.deadline
                        ).start.year
                      }
                    </h6>
                  </div>
                </div>
              </div>
            </section>
            <section className="container py-5">
              <div className="d-flex flex-column justify-content-md-center align-items-start ">
                <div
                  className="mb-5"
                  dangerouslySetInnerHTML={{
                    __html: searchResults.description,
                  }}
                ></div>
                {/* {data.map((data, index) => (
                  <div className="mb-5">
                    <h6 className="pb-1 fw-bold">{data.title}</h6>
                    {data.points.map((point, index) => (
                      <p>{point}</p>
                    ))}
                  </div>
                ))} */}
                <Link to={`/pages/career/cv-upload/${route.id}`}>
                  <button
                    className="px-3 py-2"
                    style={{
                      borderRadius: "5px",
                      backgroundColor: "#0C807D",
                      border: "none",
                      color: "white",
                    }}
                  >
                    Apply Now
                  </button>
                </Link>
              </div>
            </section>
          </main>
        ) : (
          ""
        )}
      </div>
      <Route component={Footer} />
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default CareerInside;



// WEBPACK FOOTER //
// ./src/component/frontend/CareerInside.js